import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import useDomainPath from "../hooks/useDomainPath";

const LanguageSelector = () => {
  const {
    home: {
      domain: { languageSelector: languages },
    },
  } = useStaticQuery(graphql`
    query {
      home {
        domain {
          languageSelector {
            language
            path
          }
        }
      }
    }
  `);
  const domainPath = useDomainPath();
  return languages ? (
    <select
      className="block pr-8 leading-tight text-white bg-transparent bg-right bg-no-repeat border-0 border-b border-white border-solid rounded-none appearance-none language-selector md:mx-auto focus:outline-none focus:ring"
      aria-label={languages[domainPath]}
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
      }}
      onChange={({ target: { value } }) => {
        if (value !== domainPath)
          window.location.assign(`${value}/home.html`.replace("//", "/"));
      }}
      value={domainPath}
      data-testid="languageSelector"
    >
      {languages.map((item) => (
        <option key={item.path} value={item.path}>
          {item.language}
        </option>
      ))}
    </select>
  ) : null;
};

export default LanguageSelector;
